<template>
    <v-row no-gutters class="mt-5 px-8" style="position: relative">
        <v-col cols="12" class="mb-6">
            <b-select
                v-model="transactionType"
                :items="transactionTypes"
                :item-text="lang"
                item-value="value"
                :label="translations.transactionType[lang]"
            ></b-select>
        </v-col>

        <v-col cols="12">
            <v-card outlined>
                <v-card-title
                    class="subtitle-1 font-weight-bold"
                    v-text="translations.firstCardTitle[lang]"
                ></v-card-title>
                <v-card-subtitle
                    class="pb-0"
                    v-text="translations.firstCardSubtitle[lang]"
                ></v-card-subtitle>

                <v-card-text v-if="transactionType == 1">
                    <b-text-field
                        v-model="couponWithTransaction.goal_sequence"
                        :label="translations.numberOfVisits[lang]"
                        type="number"
                    ></b-text-field>

                    <b-text-field
                        v-model="couponWithTransaction.goal_minimum_amount"
                        type="number"
                        :label="translations.minTransaction[lang]"
                    ></b-text-field>

                    <b-text-field
                        v-model="couponWithTransaction.goal_max_days"
                        type="number"
                        :label="translations.maxDays[lang]"
                    ></b-text-field>
                </v-card-text>
                <v-card-text v-else>
                    <b-text-field
                        v-model="couponWithTransaction.goal_sum_sequence"
                        type="number"
                        :label="translations.totalAmount[lang]"
                    ></b-text-field>
                </v-card-text>
            </v-card>
        </v-col>

        <!-- <v-icon
            class="b-floating-arrow"
            x-large
            v-text="icons.mdiArrowRight"
        ></v-icon> -->

        <v-col cols="12" class="mt-4">
            <v-card outlined>
                <v-card-title
                    class="subtitle-1 font-weight-bold"
                    v-text="translations.secondCardTitle[lang]"
                ></v-card-title>
                <v-card-subtitle
                    class="pb-0"
                    v-text="translations.secondCardSubtitle[lang]"
                ></v-card-subtitle>

                <v-card-text>
                    <b-text-field
                        v-model="couponWithTransaction.gift_title"
                        :label="translations.giftTitle[lang]"
                    ></b-text-field>

                    <b-textarea
                        v-model="couponWithTransaction.gift_description"
                        :label="translations.giftDescription[lang]"
                    ></b-textarea>

                    <b-text-field
                        v-model="couponWithTransaction.maximum"
                        type="number"
                        :label="translations.maximum[lang]"
                    ></b-text-field>

                    <b-select
                        v-model="couponWithTransaction.gift_category_id"
                        :items="giftCategories"
                        :item-text="`name[${lang}]`"
                        item-value="gift_category_id"
                        :label="translations.selectCategory[lang]"
                    ></b-select>

                    <v-row no-gutters>
                        <v-col cols="5" class="pa-5">
                            <v-img :src="couponWithTransaction.image"></v-img>
                        </v-col>
                        <v-col cols="7">
                            <v-file-input
                                :label="translations.uploadCoupon[lang]"
                                color="secondary"
                                class="mt-5"
                                outlined
                                dense
                                hide-details
                                @change="onFileSelected"
                            ></v-file-input>
                        </v-col>
                    </v-row>

                    <!-- <div class="text-right mt-4">
                        <v-btn
                            :color="
                                superUser || permissions.create
                                    ? 'secondary'
                                    : 'grey'
                            "
                            class="text-capitalize px-5"
                            depressed
                            v-text="translations.create[lang]"
                            @click="
                                () => {
                                    if (superUser || permissions.create) {
                                        if (transactionType == 1) {
                                            create(imageFile);
                                            imageFile = null;
                                        } else {
                                            createWithAmount();
                                        }
                                    } else {
                                        setPermissionDialog(true);
                                    }
                                }
                            "
                        ></v-btn>
                    </div> -->
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import { mdiArrowRight } from "@mdi/js";
import translations from "@/utils/translations/storePanel/coupons/couponsWithTransactions";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "PurchasedCouponsForm",

    mixins: [translations],

    data() {
        return {
            icons: { mdiArrowRight },
        };
    },

    computed: {
        ...mapState(["superUser"]),
        ...mapState("storePanel/coupons/couponsWithTransactions", [
            "couponWithTransaction",
            "giftCategories",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        permissions() {
            return this.$store.state.permissions.coupons
                ? this.$store.state.permissions.coupons.goal
                : {};
        },
    },

    methods: {
        ...mapMutations(["setPermissionDialog"]),
        ...mapActions("storePanel/coupons/couponsWithTransactions", [
            "getItem",
            "getGiftCategories",
            "create",
            "createWithAmount",
        ]),

        onFileSelected(event) {
            if (event) {
                this.imageFile = event;
                const reader = new FileReader();
                reader.readAsDataURL(this.imageFile);
                reader.onload = (e) =>
                    (this.couponWithTransaction.image = e.target.result);
            }
        },
    },

    mounted() {
        this.getItem();
        this.getGiftCategories();
    },
};
</script>